import { ChartOfAccount } from "./chart-of-account";
import { ShopCurrency } from "./shop-currency";
import { SystemField } from "./system-field";

export class PaymentMethod extends SystemField { 
     payment_type?:string;
     payment_name?:string;
     image_url?:string;
     comments?:string;
     is_default?:number;
     is_active?:number;   
     ordering?:number; 
}
